import React, { useEffect } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServices } from '../slice/carriersSlice';
import Loader from './Loader';
import { barChartColors } from '../constants';

function valueFormatter(value) {
  return `${value}`;
}

export default function ShowBarChart() {
  const dispatch = useDispatch();
  const { services = [], loading = false } = useSelector((state) => state.carriers || {});
  const userRole = useSelector((state) => state.user.userRole)
  const isAdmin = userRole === "admin";

  const monthsMap = {
    1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun',
    7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec',
  };

  const chartSetting = {
    yAxis: [
      {
        label: 'Total Sales',
      },
    ],
    width: isAdmin ? 900 : 900,
    height: 300,
  };

  const dataset = Array.from({ length: 12 }, (_, index) => ({
    month: monthsMap[index + 1],
    dhl: 0,
    ups: 0,
    usps: 0,
    go_shippo: 0,
    spedirepro: 0,
  }));

  if (services?.length > 0) {
    services.forEach((service) => {
      const { carrierName, carrierVersions } = service;

      if (['dhl', 'ups', 'usps',"go_shippo", "spedirepro"].includes(carrierName)) {
        carrierVersions?.forEach((carrierVersion) => {
          const { monthlySales } = carrierVersion || {};

          monthlySales?.forEach((sale) => {
            const { month, totalSales } = sale;

            const monthData = dataset.find((data) => data.month === monthsMap[month]);
            if (monthData) {
              monthData[carrierName] = (monthData[carrierName] || 0) + totalSales;
            }
          });
        });
      }
    });
  }

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  if (loading) return <Loader />;

  return (
    <BarChart
      colors={barChartColors}
      dataset={dataset ? dataset : []}
      xAxis={[{ scaleType: 'band', dataKey: 'month' }]}
      series={[
        { dataKey: 'dhl', label: 'DHL', valueFormatter },
        { dataKey: 'ups', label: 'UPS', valueFormatter },
        { dataKey: 'usps', label: 'USPS', valueFormatter },
        { dataKey: "go_shippo", label: "GO SHIPPO" , valueFormatter },
        { dataKey: "spedirepro", label: "SPEDIRE PRO" , valueFormatter }
      ]}
      {...chartSetting}
    />
  );
}
